import { useEffect } from 'react';
import { useGame } from '../state/store';
import { Home } from '../ui/Home';
import { Lobby } from '../ui/Lobby';
import { Game } from '../ui/Game';
import { CardGallery } from '../ui/CardGallery';
import { TooltipLayer } from '../ui/Tooltip';

const ROOM_PATH = /^\/room\/([A-Z2-9]{5})\/?$/;

export function App() {
  const mode = useGame((s) => s.mode);
  const code = useGame((s) => s.code);
  const status = useGame((s) => s.room?.status);
  const joinOnline = useGame((s) => s.joinOnline);
  const leave = useGame((s) => s.leave);

  // Join-by-link: /room/ABCDE (docs/06 §3).
  useEffect(() => {
    const sync = () => {
      const m = ROOM_PATH.exec(location.pathname);
      const s = useGame.getState();
      if (m && s.code !== m[1]) joinOnline(m[1]!);
      else if (!m && s.mode === 'online') leave();
    };
    sync();
    // A reload, or the phone relaunching the app: go straight back to the match in progress.
    const q0 = new URLSearchParams(location.search);
    if (!ROOM_PATH.test(location.pathname) && !q0.has('solo') && !q0.has('cards')) void useGame.getState().resume();
    // Shortcut for playtesting: /?solo=2 starts an offline game against 2 bots (optionally &rules=v1).
    const q = new URLSearchParams(location.search);
    const solo = Number(q.get('solo'));
    if (solo >= 1 && solo <= 4 && !useGame.getState().mode) {
      // `&res=0` plays without City Resolutions and Annex rooms (P-17, P-18).
      useGame.getState().startOffline(solo, q.get('rules') === 'v1' ? 'v1' : 'v2', q.get('res') !== '0');
      if (!q.has('autoplay')) history.replaceState(null, '', '/');
    }
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, [joinOnline, leave]);

  let screen: React.ReactNode;
  if (import.meta.env.DEV && new URLSearchParams(location.search).has('cards')) screen = <CardGallery />;
  else if (mode === 'offline') screen = <Game />;
  else if (mode === 'online' && code) screen = status === 'playing' || status === 'ended' ? <Game /> : <Lobby />;
  else screen = <Home />;
  return (
    <>
      {screen}
      <TooltipLayer />
    </>
  );
}
